// src/pages/CourseTime/components/slides/layouts/ReentryMapSlide.comp.jsx
import React from 'react';
import * as S from '../../../styles';
import NoDataFallback from '../common/NoDataFallback.comp';
import SlideTitleSpoken from '../common/SlideTitleSpoken.comp';
import { useSlideContentRenderer } from '../../../hooks/useSlideContentRenderer';

// Layout: TemplateReentryMap
const ReentryMapSlide = ({ slide, renderSpokenText, skipTitleSpeech, themeColor }) => {
  const { renderContent } = useSlideContentRenderer({ renderSpokenText, skipTitleSpeech });

  // Newer content (slide_type "closing") keeps these fields on the slide itself.
  const d = slide.ReentryData
    || ((slide.one_line_summary || slide.walked_in_with || slide.walked_out_with || slide.reentry_map) ? slide : null);
  const accent = themeColor || '#3D5AFE';
  if (!d) {
    return (
      <NoDataFallback
        slide={slide}
        skipTitleSpeech={skipTitleSpeech}
        renderSpokenText={renderSpokenText}
        renderContent={renderContent}
      />
    );
  }
  return (
    <S.SlideDescription>
      <S.SlideTitle>
        <SlideTitleSpoken slide={slide} skipTitleSpeech={skipTitleSpeech} renderSpokenText={renderSpokenText} />
      </S.SlideTitle>

      {d.one_line_summary && (
        <S.PointText style={{ marginBottom: 12 }}>
          {renderContent('reentry_summary', d.one_line_summary)}
        </S.PointText>
      )}

      {(d.walked_in_with || d.walked_out_with) && (
        <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap', margin: '8px 0 16px' }}>
          {d.walked_in_with && (
            <div style={{ flex: '1 1 240px', background: 'rgba(0,0,0,0.04)', padding: '12px 16px', borderRadius: 8 }}>
              <S.PointText><strong>You walked in with</strong></S.PointText>
              <S.PointText>{renderContent('reentry_in', d.walked_in_with)}</S.PointText>
            </div>
          )}
          {d.walked_out_with && (
            <div style={{ flex: '1 1 240px', background: `${accent}14`, padding: '12px 16px', borderRadius: 8 }}>
              <S.PointText><strong>You walked out with</strong></S.PointText>
              <S.PointText>{renderContent('reentry_out', d.walked_out_with)}</S.PointText>
            </div>
          )}
        </div>
      )}

      {d.practice_intro && (
        <S.PointText style={{ marginBottom: 8 }}>
          {renderContent('reentry_practice_intro', d.practice_intro)}
        </S.PointText>
      )}

      {d.practice_timeframe && (
        <S.PointText style={{ fontStyle: 'italic', marginBottom: 8 }}>
          When this shows up: {d.practice_timeframe}
        </S.PointText>
      )}

      {Array.isArray(d.reentry_map) && d.reentry_map.length > 0 && (
        <table style={{ width: '100%', borderCollapse: 'collapse', marginTop: 8 }}>
          <thead>
            <tr>
              <th style={{ textAlign: 'left', padding: '8px 10px', borderBottom: `2px solid ${accent}`, width: '50%' }}>
                When
              </th>
              <th style={{ textAlign: 'left', padding: '8px 10px', borderBottom: `2px solid ${accent}` }}>
                Go back to
              </th>
            </tr>
          </thead>
          <tbody>
            {d.reentry_map.map((row, idx) => (
              <tr key={idx}>
                <td style={{ padding: '8px 10px', borderBottom: '1px solid rgba(0,0,0,0.08)', verticalAlign: 'top' }}>
                  {row.workplace_moment}
                </td>
                <td style={{ padding: '8px 10px', borderBottom: '1px solid rgba(0,0,0,0.08)', verticalAlign: 'top' }}>
                  {row.return_section}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}

      {d.closing_line && (
        <S.PointText style={{ marginTop: 14, fontWeight: 600 }}>
          {renderContent('reentry_closing', d.closing_line)}
        </S.PointText>
      )}

      {d.t_plus_30_message && (
        <S.PointText style={{ marginTop: 14 }}>
          <strong>Follow-up:</strong> {renderContent('reentry_t30', d.t_plus_30_message)}
        </S.PointText>
      )}
    </S.SlideDescription>
  );
};

export default ReentryMapSlide;
